export default __webpack_public_path__ + "static/media/img10.105c7a2c.png";